module.exports = __webpack_public_path__ + "static/media/Corona-banner.9a2cc49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/Corona-banner.png
// module id = 667
// module chunks = 0